module.exports = __webpack_public_path__ + "static/img/img_form2_ko.d21830e8.png";